export const setInvitedUsers = (state, wholeObject) => {
    state.invitations = wholeObject.invitations.total
    state.invitationsPeriod = wholeObject.invitations.period
    state.flyers = wholeObject.flyers.total
    state.flyersPeriod = wholeObject.flyers.period
    state.flyersUsed = wholeObject.flyers_used.total
    state.flyersUsedPeriod = wholeObject.flyers_used.period
    state.expiredInvitations = wholeObject.expired.total.invitations
    state.expiredInvitationsPeriod = wholeObject.expired.period.invitations
    state.expiredFlyers = wholeObject.expired.total.flyers
    state.expiredFlyersPeriod = wholeObject.expired.period.flyers   
}

export const setPatients = (state, wholeObject) => {
    state.connectedWithTherapist = wholeObject.connected
    state.connectedWithTherapistToolTip = wholeObject.connected_by_state
    state.inApp = wholeObject.in_app
    state.onboarding = wholeObject.onboarding
    state.inactivated = wholeObject.inactivated
}

export const setPatientsEvents = (state, wholeObject) => {
    state.connectedWithTherapistInPeriod = {"intensive-connected": wholeObject.users['intensive-connected'], "sustain": wholeObject.users.sustain, "graduate": wholeObject.users.graduate}
    state.inAppInPeriod = wholeObject.users['intensive-inapp']
    state.onboardingInPeriod = wholeObject.users.onboarding
    state.onboardingPendingInPeriod = wholeObject.users['onboarding-pending']
    state.inactivatedInPeriod = {"intensive-inapp": wholeObject.inactivated_users['intensive-inapp'], "onboarding": wholeObject.inactivated_users.onboarding, "intensive-connected": wholeObject.inactivated_users['intensive-connected'], "sustain": wholeObject.inactivated_users.sustain, "graduate": wholeObject.inactivated_users.graduate}
    state.connectedWithTherapistEvent = wholeObject.events['intensive-connected']
    state.connectedWithTherapistEventSustain = wholeObject.events.sustain
    state.connectedWithTherapistEventGraduate = wholeObject.events.graduate
    state.inAppEvent = wholeObject.events['intensive-inapp']
    state.onboardingEvent = wholeObject.events.onboarding
    state.onboardingPendingEvent = wholeObject.events['onboarding-pending']
    state.inactivatedEvent = {"intensive-inapp": wholeObject.inactivated_events['intensive-inapp'], "onboarding": wholeObject.inactivated_events.onboarding, "intensive-connected": wholeObject.inactivated_events['intensive-connected'], "sustain": wholeObject.inactivated_events.sustain, "graduate": wholeObject.inactivated_events.graduate}
}


export const setPatientValues = (state, wholeObject) => {
    state.weight = wholeObject.weight
    state.waist = wholeObject.waist
}

export const setDoctors = (state, wholeObject) => {
    state.allDoctors = wholeObject
}